import React from "react";
import {useLocation} from "react-router-dom";
import InvoiceCredits from "../../Components/Chekout/InvoiceCredits";
import InvoiceAppointment from "../../Components/Chekout/InvoiceAppointment";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const PaymentConfirmation = () => {
    const query = useQuery();
    const type = query.get("type");

    return(
        <>
            {
                type === "appointment" ?
                    <InvoiceAppointment/>
                    :
                    <InvoiceCredits/>
            }
        </>
    );
};

export default PaymentConfirmation;
